/**
 * Marks a product we can price automatically through Pax8 and email back
 * immediately, rather than quoting by hand over a day or two.
 *
 * Only rendered for products in lib/pax8/catalog.ts. That registry is
 * deliberately small and grows one product at a time, because each vendor needs
 * different inputs before its price is real — so this badge is a promise we can
 * actually keep, not a decoration.
 */

import { Zap } from 'lucide-react';

interface InstantQuoteBadgeProps {
  /** Tighter treatment for listing cards. */
  compact?: boolean;
  /** Render on a dark hero, where the light chip would disappear. */
  onDark?: boolean;
}

export default function InstantQuoteBadge({ compact, onDark }: InstantQuoteBadgeProps) {
  const palette = onDark
    ? 'bg-white/15 text-white ring-1 ring-inset ring-white/30 backdrop-blur-sm'
    : 'bg-emerald-50 text-emerald-800 ring-1 ring-inset ring-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:ring-emerald-800';

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold ${palette} ${
        compact ? 'px-2 py-0.5 text-[11px]' : 'px-3 py-1 text-xs'
      }`}
    >
      <Zap className={compact ? 'h-3 w-3' : 'h-3.5 w-3.5'} aria-hidden="true" />
      Instant quote by email
    </span>
  );
}
